module.exports = __webpack_public_path__ + "4aa4926b0b434153237038db2be68e85.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/onboarding-daily-reading.png
// module id = 1114
// module chunks = 0